var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaBlackFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_865",
    "data-name": "Grupo 865",
    transform: "translate(-1407 -435)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_35",
    "data-name": "Elipse 35",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(1407 435)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(1416.004 444.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_234",
    "data-name": "Trazado 234",
    d: "M95.521,555.011H86.469a5.987,5.987,0,0,1-5.98-5.98v-9.052a5.987,5.987,0,0,1,5.98-5.98h9.051a5.987,5.987,0,0,1,5.981,5.98v9.052A5.987,5.987,0,0,1,95.521,555.011ZM86.469,535.8a4.184,4.184,0,0,0-4.179,4.179v9.052a4.184,4.184,0,0,0,4.179,4.179h9.051a4.184,4.184,0,0,0,4.179-4.179v-9.052a4.184,4.184,0,0,0-4.179-4.179Z",
    transform: "translate(-80.489 -533.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_235",
    "data-name": "Trazado 235",
    d: "M120.1,578.99a5.38,5.38,0,1,1,5.38-5.38A5.386,5.386,0,0,1,120.1,578.99Zm0-8.959a3.579,3.579,0,1,0,3.579,3.579A3.583,3.583,0,0,0,120.1,570.03Z",
    transform: "translate(1306.41 -119.1)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaBlackFooter);
export default __webpack_public_path__ + "static/media/InstaBlackFooter.3d6485cb77e93e78c0683e3576a11693.svg";
export { ForwardRef as ReactComponent };